'use client';

import React from 'react';
import PropTypes from 'prop-types';

ClinicList.propTypes = {
    results: PropTypes.array.isRequired,
    curTab: PropTypes.string,
};

export default function ClinicList({ results, curTab}) {
    
    return (
        <div className={` ${curTab == 'list' ? '' : 'u-hidden'}`}>
            {results.length > 0 ? (
                <div className="searchListWrapper__inner">
                    {results.map((clinic) => {

                        const mapIcon = (
                            <img
                                src={
                                    clinic.flagship
                                        ? '/wp-content/themes/bedrock-theme/static/images/clinic-marker-blue.svg'
                                        : '/wp-content/themes/bedrock-theme/static/images/clinic-marker-teal.svg'
                                }
                                alt="Map Marker Icon"
                                width={28}
                                height={46}
                            />
                        );

                        return (<div
                            key={clinic.id}
                            className={`clinic-finder__list-item`}
                        >
                            
                            
                                <h3
                                    className="searchListWrapper__title"
                                >{mapIcon} <span dangerouslySetInnerHTML={{
                                    __html: clinic.title,
                                }}></span></h3>
                                <address
                                    className="searchListWrapper__address"
                                    dangerouslySetInnerHTML={{
                                        __html: clinic.address.replace(
                                            /[<]br[^>]*[>]/gi,
                                            ''
                                        ),
                                    }}
                                ></address>
                                
                                { clinic.distance && (
                                    <p className="searchListWrapper__distance">
                                        {clinic.distance} miles <small>(approx)</small>
                                    </p>
                                )}
                                
                                <div className="clinic-finder__list-ctas">

                                    <a
                                        className="clinic-finder__clinic-link"
                                        href={clinic.url}
                                    >
                                        Clinic Details
                                    </a>

                                    <a
                                        href={`/booking-journey/?clinicID=${clinic.id}`}
                                    >
                                        Make an online booking
                                    </a>

                                </div>


                        </div>)
                    })}
                </div>
            ) : (
                <p className="searchListWrapper__error">No clinics found</p>
            )}
        </div>
    );
}
